import { useMemo } from 'react';
import { useGetModelByIdQuery } from '../../services/objects/objectModelsApi';
import { useGetLanguage } from '../useGetLanguage';

export interface useIntlPropertyDescriptionResult {
    isLoading: boolean,
    isSuccess: boolean,
    isError: boolean,
    description: string,
}

function useIntlPropertyDescription(modelId: string, propertyName: string): useIntlPropertyDescriptionResult {
    const {languageShort } = useGetLanguage();
    const { data: model, isLoading, isSuccess, isError } = useGetModelByIdQuery(modelId, { skip: !modelId || modelId === ''});

    const prop = useMemo(() => model?.flatMap(v => v.contents).find(v => firstToLower(v?.name ?? '') === propertyName),[model,propertyName]);
    const propdescriptions = prop?.description;
    const descr = propdescriptions ? propdescriptions[languageShort] : propertyName;
  
    return { isLoading, description: descr, isSuccess, isError }
}

export default useIntlPropertyDescription


function firstToLower(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}